import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes, faPen, faSave } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  startUpdateRecord,
  cancelUpdateRecord,
  handleSkipRecord,
  handleUpdateRecord
} from '../store/actions/run_records';

import { recordStatuses } from '../import_constants';
export class FixedRecordRow extends React.Component {
  static propTypes = {
    allValidImports: PropTypes.bool,
    currentStep: PropTypes.string.isRequired,
    editingRecord: PropTypes.object.isRequired,
    editRow: PropTypes.bool.isRequired,
    record: PropTypes.shape({
      duplicateCsvRow: PropTypes.number,
      errorMessage: PropTypes.string,
      id: PropTypes.number.isRequired,
      index: PropTypes.number.isRequired,
      previewStatus: PropTypes.string,
      skip: PropTypes.bool.isRequired,
    }).isRequired,
    onCancelUpdateRecord: PropTypes.func.isRequired,
    onStartUpdateRecord: PropTypes.func.isRequired,
    onToggleSkipRecord: PropTypes.func.isRequired,
    onUpdateRecord: PropTypes.func.isRequired,
  };

  previewStep = () => this.props.currentStep === "preview";

  editingRow() {
    const { editingRecord, editRow, record } = this.props;
    return (editingRecord.id === record.id && editRow);
  }

  handleUpdateRecord() {
    const { record, onStartUpdateRecord, editRow } = this.props;

    if (!this.editingRow() && !editRow) {
      onStartUpdateRecord(record, true);
    }
  }

  renderErrorMessage(record) {
    switch (record.previewStatus) {
    case recordStatuses["error"]:
      return record.errorMessage;
    case recordStatuses["duplicate"]:
      return `Duplicate of Row ${record.duplicateCsvRow}`;
    case recordStatuses["skipped"]:
      return `Skipped`;
    }
  }

  renderStatusIcon(record) {
    const statusToolTip = (
      <Tooltip id="status-tooltip" placement="top">
        <span>
          {this.renderErrorMessage(record)}
        </span>
      </Tooltip>
    );

    return (
      <OverlayTrigger overlay={statusToolTip} placement="top">
        <FontAwesomeIcon
          className={`${record.previewStatus}-icon`}
          icon={faInfoCircle}
          size="lg"
        />
      </OverlayTrigger>
    );
  }

  renderPreviewFields(record) {
    const { allValidImports, onToggleSkipRecord } = this.props;

    return (
      <React.Fragment>
        <td className="cell-small table-cell">
          <input
            checked={!record.skip}
            className="checkbox--lg"
            type="checkbox"
            onChange={() => onToggleSkipRecord(record)}
          />
        </td>
        {!allValidImports &&
          <td className="cell-small table-cell text-center record-status">
            {record.previewStatus !== recordStatuses["success"] && this.renderStatusIcon(record)}
          </td>
        }
      </React.Fragment>
    );
  }


  renderToolTip(text) {
    return (
      <Tooltip id="status-tooltip" placement="top">
        <span>
          {text}
        </span>
      </Tooltip>
    );
  }
  renderSaveAndCancelIcons() {
    const { onCancelUpdateRecord, onUpdateRecord } = this.props;

    return (
      <React.Fragment>
        <OverlayTrigger overlay={(this.renderToolTip("Cancel"))} placement="top">
          <FontAwesomeIcon
            className="edit-icon ml-3 text-danger"
            icon={faTimes}
            size="lg"
            onClick={() => onCancelUpdateRecord()}
          />
        </OverlayTrigger>
        <OverlayTrigger overlay={(this.renderToolTip("Save"))} placement="top">
          <FontAwesomeIcon
            className="edit-icon ml-3 mr-3"
            icon={faSave}
            size="lg"
            onClick={() => onUpdateRecord()}
          />
        </OverlayTrigger>
      </React.Fragment>
    );
  }

  renderEditIcon(id) {
    const { editRow } = this.props;

    const iconClass = classNames({
      "edit-icon": true,
      "ml-3": true,
      "mr-3": true,
      "text-muted": !this.editingRow(id) && editRow
    });

    return (
      <OverlayTrigger overlay={(this.renderToolTip("Edit"))} placement="top">
        <FontAwesomeIcon
          className={iconClass}
          icon={faPen}
          onClick={() => this.handleUpdateRecord(id)}
        />
      </OverlayTrigger>
    );
  }

  renderReviewFields() {
    const { record } = this.props;

    let status = record.status;

    if (status === "created") {
      status = `New ${record.mapperTypeClassLabel} Created`;
    }

    const editingRow = this.editingRow();
    return (
      <React.Fragment>
        <td className={`cell-small table-cell text-capitalize ${record.status}-cell`}>
          {status}
        </td>
        <td className="table-cell p-0">
          {editingRow && this.renderSaveAndCancelIcons()}
          {(record.status === recordStatuses.failed && !editingRow) &&
            this.renderEditIcon()}
        </td>
      </React.Fragment>
    );
  }

  renderPreviewOrReview(record) {
    if (this.previewStep()) {
      return this.renderPreviewFields(record);
    } else {
      return this.renderReviewFields();
    }
  }

  render() {
    const { record } = this.props;

    return (
      <tr className={`${record.previewStatus}-row`} key={record.id + "fixed"}>
        <td className="cell-small text-center table-cell">{record.index}</td>
        {this.renderPreviewOrReview(record)}
      </tr>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.ui.currentStep,
  editRow: state.runRecords.editRow,
  editingRecord: state.runRecords.editingRecord,
});

const mapDispatchToProps = {
  onToggleSkipRecord: handleSkipRecord,
  onCancelUpdateRecord: cancelUpdateRecord,
  onStartUpdateRecord: startUpdateRecord,
  onUpdateRecord: handleUpdateRecord
};

export default connect(mapStateToProps, mapDispatchToProps)(FixedRecordRow);
